import { render, staticRenderFns } from "./TheAccountMenu.vue?vue&type=template&id=0ff32ab2"
import script from "./TheAccountMenu.vue?vue&type=script&lang=ts"
export * from "./TheAccountMenu.vue?vue&type=script&lang=ts"
import style0 from "./TheAccountMenu.vue?vue&type=style&index=0&id=0ff32ab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports